import axios from 'axios';

async function updateDialogueRequest(user, dialogueId, message) {
  if (!user) {
    throw new Error("updateDialogueRequest(): cannot send a message if a sender has not been defined.");
  }
  if (process.env["NODE_ENV"] !== "production") {
    console.warn("updateDialogueRequest(): dialogue not sent due to NODE_ENV");
    return;
  }
  await axios.put(`${process.env["NEXT_PUBLIC__USERDATA_API"]}/api/Dialogues/${dialogueId}`, {
    author: {
      id: user.id,
      type: user.role
    },
    content: message
  });
}

export { updateDialogueRequest };
//# sourceMappingURL=api.update-dialogue.request.js.map
